<template>
<section class="container catalog">
  <div class="row grid-margin catalog__assortiment" v-if="isAssortmentFlow">
    <div class="col-xs-12 col-sm-3">
      <h1>Assortiment</h1>
    </div>
    <div class="col-xs-12">
      <div class="catalog__assortiment__alert-wrapper">
        <v-info-outline-icon class="catalog__assortiment__alert-wrapper__infoIcon"></v-info-outline-icon>
        Wilt u producten bestellen? Selecteer dan eerst een patiënt en maak een machtiging aan via <router-link to="/">Mijn Dashboard.</router-link>
      </div>
    </div>
  </div>
  <div class="row grid-margin" v-if="!isReplenishmentFlow">
    <div class="col-xs-12 col-sm-3">
      <h1>Product catalogus</h1>
    </div>
    <div class="col-xs-12 col-sm-9 catalog__productSearch" id="catalogSearch">
      <v-input-group-simple-2
       v-model="productSearchText"
       :overwriteValue="productSearchText"
       :rules="{
        required: false
       }"
       id="catalogProductSearch"
       placeholder="Zoeken naar producten"
       @input="saveProductSearchText($event)"
      >
      </v-input-group-simple-2>
      <sync-loader v-if="loading" :color="color" class="catalog__productSearch__search-icon"></sync-loader>
      <v-search-icon v-else class="catalog__productSearch__search-icon"></v-search-icon>
    </div>
  </div>
  <div class="row grid-margin">
    <form class="col-xs-12 col-md-3" v-if="!isReplenishmentFlow">
      <v-filters v-model="form.filters" :filters="filters" v-on:input="search" v-if="filters && filters.length > 0"></v-filters>
      <v-favourites v-model="form.favorites" :favourites="favourites" v-on:input="search" v-if="favourites && favourites.length > 0"></v-favourites>
      <v-manufacturers v-model="form.manufacturers" :manufacturers="manufacturers" v-on:input="search" v-if="manufacturers.length !== 0"></v-manufacturers>
      <v-overlay v-if="overlayActive">
        <v-favourites-edit-form :favourites="favourites" @close="closeOverlay"> </V-favourites-edit-form>
      </v-overlay>
      <v-categories-old v-model="form.category" v-on:input="search" v-if="categoriesOld.length !== 0 && (activeDepartment && !activeDepartment.isNewHierarchyEnabled)" :categories="categoriesOld"></v-categories-old>
      <v-categories v-model="form.category" v-on:input="search" v-if="filteredCategoryList.length !== 0 && (activeDepartment && activeDepartment.isNewHierarchyEnabled)" :categories="filteredCategoryList" :isAssortmentFlow="isAssortmentFlow"></v-categories>
    </form>
    <div :class="!isReplenishmentFlow ? 'col-xs-9': 'col-md-12'">
      <div v-if="activeTokens.length > 0 && !isReplenishmentFlow">
        <div class="col-xs-12 col-md-12">
          <v-tokens :tokens="activeTokens" :resultCount="totalProductCount"></v-tokens>
        </div>
      </div>
      <v-bundles v-if="!isProductTextSearch && bundles && bundles.length > 0 && isCustomerFlow" :bundles="bundles"></v-bundles>
      <v-products @loadMore="loadMore()" v-if="!isProductTextSearch && searchResults && searchResults.length > 0" :baseProducts="searchResults"></v-products>
      <v-search-products @loadMore="loadMore()" v-if="isProductTextSearch && searchResults && searchResults.length > 0" :searchProducts="searchResults"></v-search-products>
      <div v-if="hasError === true">
        Er is een fout opgetreden.
      </div>
    </div>
  </div>
  <generic-modal v-if="showAssortimentPopUp && !catalogAssortimentStatus">
    <template #header>
      Assortiment
    </template>
    <template #body>
      <p>
        U kunt hier het hele assortiment bekijken en uw favoriete producten beheren.
      </p>
      <p>
        Wilt u een product bestellen? Selecteer dan eerst een patiënt en maak een nieuwe machtiging aan om producten te kunnen bestellen.
      </p>
    </template>
    <template #footer>
      <div class="modal-checkbox">
        <v-checkbox-group class="checkbox-group" label="Laat dit bericht niet meer zien" :overwriteValue="assortimentRememberStatus" inputid="rememberAssortiment" @input="changeRememberAssortiment( ...arguments)"></v-checkbox-group>
      </div>
      <v-button tagelement="button" md primary @click.native="closeModal">Naar assortiment</v-button>
    </template>
  </generic-modal>
</section>
</template>

<script>
import 'intro.js/minified/introjs.min.css'
import introJs from 'intro.js'
import $ from 'jquery'
import { mapGetters } from 'vuex'
import VProducts from './Products'
import VSearchProducts from './searchProducts/SearchProducts'
import VFilters from './Filters'
import VFavourites from './Favourites'
import VManufacturers from './Manufacturers'
import VCategoriesOld from './Categories'
import VCategories from './categories/Categories'
import VTokens from './Tokens'
import store from '@/store'
import router from '@/router'
import VFavouritesEditForm from './FavouritesEditForm'
import VBundles from './Bundles'
import VSearchIcon from 'icons/Magnify'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import GenericModal from '@/components/shared/GenericModal'
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup'
import VInfoOutlineIcon from 'icons/InformationOutline'
import { Subject, from } from 'rxjs';
import { getReplenishmentBaseProducts, activeDepartment$ , currentUserIdentity$} from '@/services';
import { switchMap, refCount, publishReplay, map, concatMap, startWith, scan, publishBehavior, tap, catchError } from 'rxjs/operators';
import axios from 'axios';

const filterAccountableProducts = { label: 'Toon alleen gemachtigde', tokenLabel: 'Gemachtigde' };

export default {
  name: 'catalog',
  components: {
    VProducts,
    VSearchProducts,
    VFilters,
    VCategoriesOld,
    VCategories,
    VTokens,
    VFavourites,
    VManufacturers,
    VFavouritesEditForm,
    VBundles,
    VSearchIcon,
    SyncLoader,
    GenericModal,
    VCheckboxGroup,
    VInfoOutlineIcon
  },
  subscriptions () {
    const searchResults$ = this.productsRequestSubject$.pipe(
      switchMap(request => this.productsLoadMoreSubject$.pipe(
          startWith(0),
          tap(() => {
            this.loadingSubject$.next(true);
          }),
          concatMap(
            (_, pageNum) => {
              if(this.isReplenishmentFlow)
              {
                return getReplenishmentBaseProducts({pageIndex: pageNum});
              }
              else {
                const url = request + "&pageIndex=" + (pageNum + 1);
                return from(axios.get(url)).pipe(catchError(() => { return Promise.resolve({ data: { totalProducts: -1, error: true, products: []} }) }), map(r => r.data))
              }
            }
          ),
          scan((previous, p) => {
            if(!p) {
              return previous
            }
            return {
              totalProducts: p.totalProducts,
              error: p.error,
              products: [ ...previous.products, ...p.products.map(product => Object.assign(product, { isExpanded: false })) ]
            };
          }, { totalProducts: 0, products: [] }),
          tap(() => this.loadingSubject$.next(false)),
          publishBehavior({ totalProducts: -1, error: false, products: []}) /* initial value: e.g. at startup and when filters/categories/text change occur */,
          refCount()
        )
      ),
      publishReplay(1),
      refCount()
    );

    return {
      currentUserIdentity: currentUserIdentity$,
      activeDepartment: activeDepartment$,
      loading: this.loadingSubject$.asObservable(),
      hasError: searchResults$.pipe(
        map(r => r.error)
      ),
      searchResults: searchResults$.pipe(
        map(r => r.products)
      ),
      totalProductCount: searchResults$.pipe(
        map(r => r.totalProducts)
      )
    };
  },
  data () {
    return {
      productsRequestSubject$: new Subject(),
      productsLoadMoreSubject$: new Subject(),
      loadingSubject$: new Subject(),

      intro: introJs(),
      color: '#73c8d2',

      showAssortimentPopUp: false,

      // filters
      filters: [],

      // textual search
      productSearchText: "",
      productSearchTextTimer: null,

      assortimentRememberStatus: false,
      filteredCategories: [],
    }
  },
  computed: {
    filteredCategoryList() {
      if(this.form.filters.length > 0) {
        return this.filteredCategories;
      } else {
        return this.categories;
      }
    },
    isProductTextSearch () {
      return !!this.form.text;
    },
    activeTokens () {
      const result = [];

      if(this.form.text) {
        result.push({
          label: "Zoekterm: " + this.form.text,
          remove: () => {
            this.form.text = null;
            this.productSearchText = "";
            this.search();
          }
        });
      }

      if(this.form.filters.length > 0) {
        this.form.filters.forEach((filter, index) => {
          result.push({
            label: filter.tokenLabel,
            remove: () => {
              this.form.filters.splice(index, 1);
              this.search();
            }
          })
        });
      }

      if(this.form.favorites.length > 0) {
        this.form.favorites.forEach((favorite, index) => {
          result.push({
            label: "Favoriet: " + favorite.name,
            remove: () => {
              this.form.favorites.splice(index, 1);
              this.search();
            }
          })
        });
      }

      if(this.form.manufacturers.length > 0) {
        this.form.manufacturers.forEach((manufacturer, index) => {
          result.push({
            label: "Fabrikant: " + manufacturer,
            remove: () => {
              this.form.manufacturers.splice(index, 1);
              this.search();
            }
          })
        });
      }

      if(this.form.category) {
        result.push({
          label: this.activeDepartment && this.activeDepartment.isNewHierarchyEnabled ? this.form.category.description : this.form.category.omschrijving,
          remove: () => {
            this.form.category = null;
            this.search();
          }
        })
      }

      return result;
    },
    ...mapGetters({
      favorites: 'catalog/getFavorites',
      categoriesOld: 'catalog/getCategories',
      categories: 'catalog/getNewCategories',
      overlayActive: 'catalog/getOverlay',
      favourites: 'catalog/getFavoriteCategories',
      bundles: 'catalog/getBundles',
      catalogAssortimentStatus: 'catalog/getCatalogAssortiment',
      manufacturers: 'catalog/getManufacturers',
      form: 'catalog/getCatalogFormDetails',
      patientDetails: 'patient/getPatientGegevens'
    }),
    isReplenishmentFlow () {
      return router.currentRoute.meta.flow === "replenishment";
    },
    isAssortmentFlow () {
      return router.currentRoute.meta.flow === "assortment";
    },
    isCustomerFlow () {
      return router.currentRoute.meta.flow === "customer";
    },
  },
  created () {

    if (router.currentRoute.meta.flow !== "assortment"){
      this.filteredCategories  = this.categories.filter(obj => this.currentUserIdentity.userTreatmentArea.map(area => area.treatmentAreaId).includes(obj.treatmentAreaId));
    } else {
      this.filteredCategories = this.categories;
    }

    // Build filters
    if (store.state.navigation.siteCode !== 'MTF' && this.isCustomerFlow) {
      this.filters.push(filterAccountableProducts);
    }

    if (!this.isReplenishmentFlow && !this.isAssortmentFlow) {
      store.dispatch('patient/getCurrentPatient')
      store.dispatch('catalog/fetchBundles')
    }
    if (this.isAssortmentFlow) {
      this.showAssortimentPopUp = true
    }
    if (!this.isReplenishmentFlow) {
      store.dispatch('catalog/fetchFilters')
      store.dispatch('catalog/fetchManufacturers')
      store.dispatch('catalog/fetchFavourites')
      store.dispatch('catalog/fetchCategories')
    }
    if (store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.catalogFlow) {
      setTimeout(() => {
        const self = this
        this.intro.setOptions({
          steps: [
            {element: '#catalogSearch', intro: 'Er zijn meerdere manieren om je product te vinden. Zo is er bijvoorbeeld de zoekfunctie. Hiermee kan je op de naam, nummer of fabrikant van het product zoeken. Klik op volgende om door te gaan.', position: 'right'},
            {element: '#catalogFilters', intro: 'Daarnaast kan je ook filteren binnen de producten. Selecteer je "Toon alleen gemachtigde" dan krijg je alleen maar producten te zien die vergoed worden voor de patient. Selecteer "Toon alleen apparaten" dan krijg je alleen maar apparaten te zien zoals pompen. Selecteer "Toon alleen gemachtigde" en klik op volgende om door te gaan.', position: 'right'},
            {element: '#catalogFavourites', intro: 'Daarnaast kan je ook favorieten lijsten maken zodat je makkelijk eigen lijsten kan aanmaken. Selecteer bijvoorbeeld maar eens een favorietenlijst. Onderaan krijg je dan de mogelijkheid om de gehele lijst met 1 druk op de knop te bestellen. Druk op volgende om door te gaan.', position: 'right'},
            {element: '#catalogBundles', intro: 'Als laatste heeft Mediq ook een selectie aan producten gemaakt die wij aanraden voor deze patient aan de hand van zijn ziektebeeld. Klik op de titel om de inhoudt te zien of op "Bestellen" om de gehele lijst in 1 keer te bestellen. Druk op volgende om door te gaan.', position: 'right'},
            {element: '#catalogProducts', intro: 'Als je op "Toon meer" klikt dan krijg je alle varianten van het product te zien. Zo zie je de verschillende maten, smaken of soorten die Mediq beschikbaar heeft. Klik je op de titel en dan krijg je alle informatie te zien van het product. Klik op de titel van 1 van de producten om door te gaan.', position: 'right'}
          ],
          exitOnEsc: false,
          exitOnOverlayClick: false,
          skipLabel: 'Overslaan',
          nextLabel: 'Volgende >',
          prevLabel: '< Terug',
          doneLabel: 'Okey, begrepen'
        })
        this.intro.start().onchange(function () {
          $('html, body').animate({scrollTop: 0}, 'slow')
        }).oncomplete(function () {
          self.intro.exit()
        })
      }, 1500)
    }
  },
  mounted () {
    this.search();
  },
  watch: {
    'form.filters': {
      handler(newFilters, oldFilters) {
        if (router.currentRoute.meta.flow !== "assortment"){
            this.categories = this.categories.filter(obj => this.currentUserIdentity.userTreatmentArea.map(area => area.treatmentAreaId).includes(obj.treatmentAreaId));
        }

        if (newFilters.length > 0 && newFilters.includes(filterAccountableProducts)) {
          this.filteredCategories = this.categories.filter(obj => store.state.patient.patientGegevens.TreatmentAreas.includes(obj.treatmentAreaId));
        } else {
          this.filteredCategories = this.categories;
        }
      },
      immediate: true
    }
  },
  methods: {
    search () {
      // Build xhr request
      // Note: Search functionality requires additional refactoring.
      // Note 2: When replenishment flow is active this search url will not be used, instead the subject will trigger replenishment xhr request within the observable (see `subscriptions`).
      let apiCall = this.isProductTextSearch
        ? 'Catalogue/SearchProductFromCatalogue'
        : 'Catalogue/GetBaseProducts';

      // let apiCall = this.isProductTextSearch
      //   ? 'Products/Search'
      //   : 'Products/GetBaseProducts';

      // slight rule override when Favorite is active rather use Search Proc than GetBaseProduct (E40-7784)
      if(this.form.favorites.length > 0)
      {
        apiCall = 'Products/Search';
      }

      apiCall += this.isAssortmentFlow
        ? '?ignoreCustomer=true'
        : '?ignoreCustomer=false';

      apiCall += this.isAssortmentFlow
        ? '&customerId=null'
        : '&customerId=' + this.patientDetails.PatientId;

      if(this.isProductTextSearch)
      {
        apiCall += '&term=' + encodeURIComponent(this.form.text);
      }

      if(this.form.filters.includes(filterAccountableProducts)) {
        apiCall += '&IsLicensed=true';
      }

      if(this.form.favorites.length > 0) {
        this.form.favorites.forEach((favorite) => {
          apiCall += '&BundleIdList=' + favorite.bundleId;
        });
      }

      if(this.form.manufacturers.length > 0) {
        this.form.manufacturers.forEach((manufacturer) => {
          apiCall += '&manufacturer=' + manufacturer;
        });
      }

      if(this.form.category) {
        let groupIds = this.activeDepartment && this.activeDepartment.isNewHierarchyEnabled ? this.form.category.nestedCategoryIds : this.form.category.productGroepId
        groupIds.forEach((groupId) => {
          apiCall += '&CategoryIdList=' + groupId;
        });
      }

      this.productsRequestSubject$.next(apiCall);
      return;
    },
    loadMore () {
      this.productsLoadMoreSubject$.next(true); // just move to next pageIndex, no need to pass index as it is handled within pipe.
    },
    /**
     * @function changeRememberAssortiment -  Function to set remember assortiment service true or false based on user interaction
     * @param {boolean} - active
     */
    changeRememberAssortiment (active) {
      this.assortimentRememberStatus = active
    },
    closeModal () {
      this.showAssortimentPopUp = false
      store.commit('catalog/setRememberAssortiment', this.assortimentRememberStatus)
    },
    closeOverlay () {
      store.commit('catalog/setOverlayActive', false)
    },
    saveProductSearchText (event) {
      if(this.productSearchTextTimer) {
        clearTimeout(this.productSearchTextTimer);
      }
      const text = event.target.value;
      // this.productSearchText = text;
      this.productSearchTextTimer = setTimeout(() => {
        if(text.length >= 3) {
          this.form.text = text;
        }
        else {
          this.form.text = null;
        }

        this.search();
      }, 300);
    },
    getVisibilityStatus () {
      return !this.isReplenishmentFlow;
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!to.meta.catalogFilters) {
      store.commit('catalog/resetCatalogFormDetails')
    }
    next()
  }
}
</script>
<style land="css">
  .catalog .overlay > div {
    min-width: 800px;
    padding: 0px;
  }
</style>

<style lang="scss" scoped>
.catalog {
  &__assortiment {
    fill: $smooth-blue;
    color:  $smooth-blue;
    font-size: 15px;
    &__alert-wrapper {
      background-color: $lightest-blue;
      padding: 15px;
      font-style: italic;
      .material-design-icon {
        fill: $smooth-blue !important;
        display: inline-block;
        vertical-align: middle;
      }
      a {
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
  .checkbox-group {
    display: flex;
    align-items: center;
  }
  .modal-checkbox {
    display: flex;
    padding-right: 10px;
  }
  &__productSearch {
    position: relative;
    &__search-icon {
      position: absolute;
      fill: $gray-dark;
      right: 30px;
      top: 20%;
    }
  }
  h1 {
    color: $teal-darkest;
    font-weight: 300;
    font-size: type-scale(4);
    line-height: line-height(4);
    margin-top: 0;
  }
  .filters, .favourite, .manufacturers {
    margin-bottom: 32px;
  }
}
</style>
